<section class="partners-page">
  <section class="partners-content-section" id="partenaires">
    <div class="container">
      @for (category of [
        { key: 'cameroon', fr: 'Au Cameroun', en: 'In Cameroon' },
        { key: 'france', fr: 'En France', en: 'In France' },
        { key: 'other', fr: 'Autres partenaires', en: 'Other partners' },
        { key: 'church', fr: 'Églises partenaires', en: 'Partner churches' }
      ]; track category.key) {
        @if (byCategory($any(category.key)).length) {
          <div class="partners-category">
            <h2>{{ fallback(category.fr, category.en) }}</h2>
            <div class="partners-grid-cards" [class.churches-grid]="category.key === 'church'">
              @for (partner of byCategory($any(category.key)); track partner.id) {
                <article class="partner-card featured-partner" [class.church-card]="category.key === 'church'">
                  @if (partner.logo_url) {
                    <div class="partner-logo-container">
                      <img [src]="mediaUrl(partner.logo_url)" [alt]="'Logo ' + partner.name" class="partner-logo church-logo" (error)="hideBrokenImage($event)">
                    </div>
                  } @else if (category.key === 'church') {
                    <div class="church-icon" aria-hidden="true">⛪</div>
                  }
                  <div class="partner-info church-details">
                    <h3>{{ partner.name }}</h3>
                    @if (description(partner)) { <p class="partner-fullname">{{ description(partner) }}</p> }
                    @if (address(partner)) { <p class="address">{{ address(partner) }}</p> }
                    @if (partner.website_url) {
                      <a [href]="partner.website_url" target="_blank" rel="noopener noreferrer" class="church-link">{{ fallback('Voir le site', 'Visit website') }}</a>
                    }
                  </div>
                </article>
              }
            </div>
          </div>
        }
      }
    </div>
  </section>
</section>
